// extracted by mini-css-extract-plugin
export default {"layout":"LayoutContest_layout__Veh7J","layoutContent":"LayoutContest_layoutContent__FSHgQ","unidentified":"LayoutContest_unidentified__++Cbo"};